import { render, staticRenderFns } from "./CenterCmp.vue?vue&type=template&id=4ffbafe2&scoped=true&"
import script from "./CenterCmp.vue?vue&type=script&lang=js&"
export * from "./CenterCmp.vue?vue&type=script&lang=js&"
import style0 from "./CenterCmp.vue?vue&type=style&index=0&id=4ffbafe2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ffbafe2",
  null
  
)

export default component.exports